import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  ShimmerShapes, getShimmerMap, ShimmerAnimation, ShimmerAnimationClass,
  ShimmerColors,
  ShimmerColorClass,
} from './constants';
import './shimmer.scss';

const Shimmer = ({
  shape, width, height, color, radius, animation, className,
}) => {
  const renderShimmerUI = ({ shape: shimmerType, ...shimmerArgs }) => {
    const shimmerMap = getShimmerMap(shimmerArgs);
    return shimmerMap[shimmerType];
  };
  return renderShimmerUI({
    shape,
    width,
    height,
    radius,
    className: clsx(['shimmer', className,
      ShimmerAnimationClass[animation], `shimmer-type-${shape}`, ShimmerColorClass[color]]),
  });
};

Shimmer.propTypes = {
  shape: PropTypes.oneOf(Object.values(ShimmerShapes)),
  animation: PropTypes.oneOf(Object.values(ShimmerAnimation)),
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  radius: PropTypes.string,
  color: PropTypes.oneOf(Object.values(ShimmerColors)),
};

Shimmer.defaultProps = {
  shape: ShimmerShapes.RECTANGLE,
  animation: ShimmerAnimation.SHIMMER,
  color: ShimmerColors.gray100,
};

export default Shimmer;
